import { IEvent } from "@quest/adapter-interface";
import { ISpineData, SpineBase,ingenuity } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { GameParserModel } from "../../Platform/GameParserModel";

export class FlowerOnionTrailView extends BaseViewBehavior {
    public resize(evt: IEvent): void {
        //
    }
    /**
     * to clone animations
     */
    public cloneSpine(): SpineBase {
        let trailSpineObj: ISpineData = ingenuity.assetsData.getJSONById("main_data").flowerCollectTrail["skull_trail"];
        trailSpineObj.type = "spine";
        let trailSpineAnim: SpineBase = this.createSpine(trailSpineObj);
        trailSpineAnim.visible = true;
        return trailSpineAnim;
    }
    /**
     * to allign trail as per different positions
     */
    public allignTrailSpine(spine:SpineBase,reel:number,trailpos:number):void{
        spine.y = this.json.trailsAllignY[trailpos]
        spine.x = this.json.allignTrailXOnReel[reel][trailpos][(ingenuity.parserModel as GameParserModel).getCollectedFlowers()[reel] - 1]
    }
}
